import type { Feature, SystemFeatureCode } from "../models";

export const SYSTEM_FEATURE_CODES: SystemFeatureCode[] = [
  "hr",
  "organization",
  "leave",
  "attendance",
  "schedule",
  "performance",
  "compensation",
  "training",
  "career",
  "payroll",
  "recruitment",
  "crm",
  "tickets",
  "itsm",
  "problems",
  "changes",
  "projects",
  "knowledge",
  "contracts",
  "billing",
  "service_catalog",
  "assets",
  "inventory",
  "product_catalog",
  "hospitol",
  "mineportal",
  "subportal",
  "edu",
  "security",
  "analytics",
  "api",
  "identity",
  "reports",
  "customer_portal",
  "service_requests",
  "approvals",
  "automation",
];

export const SEED_FEATURES: Feature[] = [
  {
    id: "feat-hr",
    code: "hr",
    name: "Human Resources",
    module: "hrm",
    enabled: true,
    description: "Employés, départements, présences, congés",
  },
  {
    id: "feat-organization",
    code: "organization",
    name: "Organization",
    module: "hrm",
    enabled: true,
    description: "Départements, postes et structure organisationnelle",
  },
  {
    id: "feat-leave",
    code: "leave",
    name: "Leave Management",
    module: "hrm",
    enabled: true,
    description: "Congés, soldes, approbations et calendrier",
  },
  {
    id: "feat-attendance",
    code: "attendance",
    name: "Attendance Management",
    module: "hrm",
    enabled: true,
    description: "Présences, sessions et statistiques",
  },
  {
    id: "feat-schedule",
    code: "schedule",
    name: "Work Schedules & Shifts",
    module: "hrm",
    enabled: true,
    description: "Horaires, shifts et affectations",
  },
  {
    id: "feat-performance",
    code: "performance",
    name: "Performance Management",
    module: "hrm",
    enabled: true,
    description: "Objectifs, KPIs, évaluations et scores",
  },
  {
    id: "feat-compensation",
    code: "compensation",
    name: "Compensation & Adjustments",
    module: "hrm",
    enabled: true,
    description: "Règles de rémunération, primes et ajustements paie",
  },
  {
    id: "feat-training",
    code: "training",
    name: "Training & Learning",
    module: "hrm",
    enabled: true,
    description: "Cours, affectations, certifications et recommandations",
  },
  {
    id: "feat-career",
    code: "career",
    name: "Career & Succession",
    module: "hrm",
    enabled: true,
    description: "Parcours carrière, promotion readiness et succession",
  },
  {
    id: "feat-payroll",
    code: "payroll",
    name: "Payroll",
    module: "finance-accounts",
    enabled: true,
    description: "Paie et bulletins",
  },
  {
    id: "feat-recruitment",
    code: "recruitment",
    name: "Recruitment",
    module: "recruitment",
    enabled: true,
    description: "Offres et candidats",
  },
  {
    id: "feat-crm",
    code: "crm",
    name: "CRM",
    module: "crm",
    enabled: true,
    description: "Contacts, entreprises, deals",
  },
  {
    id: "feat-tickets",
    code: "tickets",
    name: "Tickets",
    module: "tickets",
    enabled: true,
    description: "Support et helpdesk",
  },
  {
    id: "feat-itsm",
    code: "itsm",
    name: "ITSM",
    module: "itsm",
    enabled: true,
    description: "Incidents, tickets IT et SLA",
  },
  {
    id: "feat-problems",
    code: "problems",
    name: "Problem Management",
    module: "msp",
    enabled: true,
    description: "Gestion des problems ITIL",
  },
  {
    id: "feat-changes",
    code: "changes",
    name: "Change Management",
    module: "msp",
    enabled: true,
    description: "Gestion des changes",
  },
  {
    id: "feat-projects",
    code: "projects",
    name: "MSP Projects",
    module: "msp",
    enabled: true,
    description: "Projets MSP client",
  },
  {
    id: "feat-knowledge",
    code: "knowledge",
    name: "Knowledge Base",
    module: "msp",
    enabled: true,
    description: "Base de connaissances MSP",
  },
  {
    id: "feat-contracts",
    code: "contracts",
    name: "MSP Contracts",
    module: "contracts",
    enabled: true,
    description: "Clients et contrats MSP",
  },
  {
    id: "feat-billing",
    code: "billing",
    name: "MSP Billing",
    module: "contracts",
    enabled: true,
    description: "Profils de facturation MSP",
  },
  {
    id: "feat-service-catalog",
    code: "service_catalog",
    name: "Service Catalog",
    module: "contracts",
    enabled: true,
    description: "Catalogue de services MSP",
  },
  {
    id: "feat-assets",
    code: "assets",
    name: "Assets",
    module: "assets",
    enabled: true,
    description: "Gestion des actifs IT",
  },
  {
    id: "feat-inventory",
    code: "inventory",
    name: "Inventory",
    module: "inventory",
    enabled: true,
    description: "Catalogue articles, entrepôts et niveaux de stock",
  },
  {
    id: "feat-product-catalog",
    code: "product_catalog",
    name: "Product Catalog",
    module: "product",
    enabled: true,
    description: "Master Product Management — références produit transverses",
  },
  {
    id: "feat-hospitol",
    code: "hospitol",
    name: "Hospitol",
    module: "hospitol",
    enabled: true,
    description: "Plateforme hospitalière — patients, pharmacie, labo, stock",
  },
  {
    id: "feat-edu",
    code: "edu",
    name: "ITaaS Edu",
    module: "edu",
    enabled: true,
    description: "Gestion scolaire — élèves, classes, notes, absences",
  },
  {
    id: "feat-mineportal",
    code: "mineportal",
    name: "Mining Company Portal",
    module: "mineportal",
    enabled: true,
    description: "Portail entreprise minière — sites, magasins, sous-traitance ARSP",
  },
  {
    id: "feat-subportal",
    code: "subportal",
    name: "ITaaS SubPortal",
    module: "subportal",
    enabled: true,
    description: "Portail sous-traitant ARSP — conformité, lots, exécution métier",
  },
  {
    id: "feat-security",
    code: "security",
    name: "Security",
    module: "security",
    enabled: true,
    description: "Gestion des operations de securite privee",
  },
  {
    id: "feat-analytics",
    code: "analytics",
    name: "Analytics",
    module: "analytics",
    enabled: true,
    description: "Tableaux de bord analytiques",
  },
  {
    id: "feat-api",
    code: "api",
    name: "API",
    module: "api",
    enabled: true,
    description: "Accès API REST",
  },
  {
    id: "feat-identity",
    code: "identity",
    name: "Identity",
    module: "identity",
    enabled: true,
    description: "Gestion utilisateurs et rôles",
  },
  {
    id: "feat-reports",
    code: "reports",
    name: "Reports",
    module: "reports",
    enabled: true,
    description: "Rapports avancés",
  },
  {
    id: "feat-customer-portal",
    code: "customer_portal",
    name: "Customer Portal",
    module: "customer-portal",
    enabled: true,
    description: "Portail client SaaS MSP",
  },
  {
    id: "feat-service-requests",
    code: "service_requests",
    name: "Service Requests",
    module: "service-requests",
    enabled: true,
    description: "Demandes de service et catalogue",
  },
  {
    id: "feat-approvals",
    code: "approvals",
    name: "Service Approvals",
    module: "service-requests",
    enabled: true,
    description: "Workflow d'approbation des demandes",
  },
  {
    id: "feat-automation",
    code: "automation",
    name: "Service Automation",
    module: "service-requests",
    enabled: true,
    description: "Automation provisioning (simulée)",
  },
];
